import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import ar from 'vuetify/lib/locale/ar';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    customVariables: ['~/variables.scss'],
    rtl: true,
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#b40001',
                secondary: '#757575',
                accent: '#82B1FF',
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107',
                mild_gray: '#818181',
                home_gray: '#ededed',
            },
        },
    },
    lang: {
        locales: { ar },
        current: 'ar',
    },
});
